import { DELETE_FAQ_START } from '../../types';

export const delete_faqs = (payload) => ({
  type: DELETE_FAQ_START,
  payload,
});
